import Subscription from "@/js/shared/classes/Subscription/Subscription";
import moment from "moment";
import {formatMoney, formatNumber, getPackageTierById} from "@/js/shared/helper";
import {subscriptionColors} from "@/js/shared/constants";

export default class ClinicalSubscription extends Subscription {
    constructor(data) {
        super(data)
        // expose isPrePaid on the instance so tables can branch on it without reaching into
        // this.data. Accept both casings since the Portal's two JSON serializers disagree:
        // System.Text.Json emits camelCase but Newtonsoft.Json (DefaultContractResolver, set
        // in StartupShared.cs:463) preserves PascalCase, and which one runs depends on the
        // endpoint.
        this.isPrePaid = data.isPrePaid ?? data.IsPrePaid ?? false
    }

    getSubscriptionForm = () => {
        const {
            subscriptionStartDate,
            subscriptionEndDate,
            isDemo,
            systemFee,
            isManualBilling,
            profilePrice,
            billingCycle,
            doNotRenew,
            isFree,
            productSubscriptionId,
            profileCount,
            packageTier,
            manualEstimatedTotal,
            isPrePaid,
            profileAddOnCount,
            freeProfilesCount,
            snoozeInvoice,
            snoozeOverage,

            updateFutureSubscriptions
        } = this.data;

        return {
            subscriptionStartDate,
            subscriptionEndDate,
            billingCycle,
            profileCount,
            profilePrice,
            packageTier,
            systemFee,
            isManualBilling,
            isDemo,
            productSubscriptionId,
            isFree,
            doNotRenew,
            isPrePaid: isPrePaid || false,
            isClinical: true,
            manualEstimatedTotal,
            profileAddOnCount,
            freeProfilesCount,
            snoozeInvoice,
            snoozeOverage,

            updateFutureSubscriptions
        }
    }

    static getNewClinicalSubscriptionForm = () => {
        return {
            subscriptionStartDate: null,
            subscriptionEndDate: null,
            billingCycle: null,
            profileCount: null,
            profilePrice: null,
            packageTier: null,
            systemFee: null,
            isManualBilling: false,
            isDemo: false,
            productSubscriptionId: null,
            isFree: false,
            doNotRenew: false,
            isPrePaid: null,
            isClinical: true,
            manualEstimatedTotal: null,
            profileAddOnCount: null,
            freeProfilesCount: null,
            snoozeInvoice: false,
            snoozeOverage: false,

            updateFutureSubscriptions: false
        }
    }
    
}